import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import loadAppsCatalog from '@/redux/actions/pieveActions/loadAppsCatalog.js';
import { getConnections } from '@/redux/requests/connectionsRequests.js';
import AppDetailPage from './pages/AppDetailPage.jsx';
import ConnectionsPage from './pages/ConnectionsPage.jsx';
import './styles/connections.css';

/** Connections: the apps Pieve works in. Loads the catalog and the person's connections once. */
const ConnectionsScreen = () => {
  const dispatch = useDispatch();
  const { appSlug } = useParams();

  useEffect(() => {
    dispatch(loadAppsCatalog());
    getConnections();
  }, [dispatch]);

  return appSlug ? <AppDetailPage appSlug={appSlug} /> : <ConnectionsPage />;
};

export default ConnectionsScreen;
